export default __webpack_public_path__ + "assets/Lato-Bold.636be8de934918e38ed94b9d68e67fe0.ttf";